import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { postWorkspaceQuizLock } from '../../../api/workspaces/lock';

export function useCreateWorkspaceQuizLock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postWorkspaceQuizLock,
    onSuccess: (_data, { workspaceId, workspaceQuizId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.byWorkspaceQuizId({
          workspaceId,
          workspaceQuizId,
        })
      );
    },
  });
}
